'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from 'react';
import { useIntersectionObserver } from './use-intersection-observer';

/** Start nearby panels on visibility or selection, and retain them after scrolling away. */
export function useViewportActivation() {
  const $ = _c(4);
  const ref = useRef(null);
  const [requested, setRequested] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      rootMargin: "200px",
      once: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    isIntersecting
  } = useIntersectionObserver(ref, t0);
  const t1 = requested || isIntersecting;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setRequested(true);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1) {
    t3 = {
      ref,
      enabled: t1,
      activate: t2
    };
    $[2] = t1;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}